export default __webpack_public_path__ + "static/media/photo--lg--65.d1dea3e7.jpg";